import React from "react";
import translate from "../../../Utils/translate";
import FieldRadioButton from "./FieldRadioButton";

const options = [
  {
    label: translate("forms.radio.personal"),
    value: "personal",
  },
  {
    label: translate("forms.radio.work"),
    value: "work",
  },
];

const FieldAccountType = ({ formik, required }) => {
  return (
    <React.Fragment>
      <h2>
        {translate("pages.account_modal.account_type")}
        {required && " *"}
      </h2>
      <FieldRadioButton
        errors={formik.errors}
        name="tags"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        options={options}
        required={required}
        touched={formik.touched}
        value={formik.values?.tags}
      />
    </React.Fragment>
  );
};

FieldAccountType.defaultProps = {
  required: false,
};

export default FieldAccountType;
